import axios from 'axios';

/**
 * Handles session termination: clears auth data and redirects to login.
 */
function handleSessionTerminated() {
  localStorage.setItem('logoutReason', 'session_terminated');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiration');
  window.location.href = '/signin';
}

/**
 * Checks an axios error for session termination signals from the backend.
 */
function isSessionTerminated(error) {
  if (!error.response) return false;
  if (error.response.status !== 401) return false;

  // Check custom header
  const headers = error.response.headers;
  if (headers && headers['x-session-expired'] === 'true') return true;

  // Check response body - handle both parsed object and raw string
  let data = error.response.data;
  if (typeof data === 'string') {
    try { data = JSON.parse(data); } catch (_) { /* ignore */ }
  }
  if (data?.code === 'SESSION_TERMINATED') return true;
  if (data?.message?.includes?.('session has been terminated')) return true;

  return false;
}

/**
 * Global response interceptor on the default axios instance.
 * This ensures ALL axios calls across the app (including raw axios.post()
 * in DynamicService, payment, etc.) will handle session termination.
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isSessionTerminated(error)) {
      handleSessionTerminated();
    }
    return Promise.reject(error);
  }
);

/**
 * Custom axios instance for new code that wants a pre-configured baseURL.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isSessionTerminated(error)) {
      handleSessionTerminated();
    }
    return Promise.reject(error);
  }
);

export default api;